import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  text: 'Excelente trabajo. Mi auto quedó mejor que cuando lo compré. Muy recomendable.',
  author: 'Martín G.'
}, {
  text: 'Profesionalismo de principio a fin. Puntuales y muy detallistas.',
  author: 'Lucas R.'
}, {
  text: 'Se nota la diferencia con otros lavaderos. Atención impecable.',
  author: 'Federico M.'
}, {
  text: 'El interior quedó espectacular. Volveré sin dudas.',
  author: 'Carla P.'
}, {
  text: 'La mejor experiencia de detailing que tuve en la zona.',
  author: 'Sebastián A.'
}];
export function Testimonials() {
  return <section className="py-16 bg-brand-darker relative border-t border-white/5" data-id="element-112">
      <div className="container mx-auto px-4 md:px-6" data-id="element-113">
        <FadeIn className="text-center mb-10" data-id="element-114">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-115">
            Resultados que hablan por{' '}
            <span className="text-brand-red" data-id="element-116">nosotros</span>
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto" data-id="element-117"></div>
        </FadeIn>

        <div className="flex flex-wrap justify-center gap-6" data-id="element-118">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.1 * index} className="bg-brand-gray/30 border border-white/5 p-8 rounded-sm w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] flex flex-col justify-between" data-id="element-119">
              <div data-id="element-120">
                <div className="flex gap-1 mb-6" data-id="element-121">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-red text-brand-red" data-id="element-122" />)}
                </div>
                <p className="text-brand-silver text-lg italic mb-6 leading-relaxed" data-id="element-123">
                  "{testimonial.text}"
                </p>
              </div>
              <div className="font-heading tracking-wider text-brand-red uppercase" data-id="element-124">
                — {testimonial.author}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}